export default "__VITE_ASSET__R3Q1PmDz__"